export default {
  state: {
    knowledgeBaseSearchResults: [
      {
        matchScore: 'Best match',
        size: 2,
        sectionsCard: [
          {
            title:
              'Lorem1 ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor?',
            content:
              'Lorem ipsum dolor sit amet,<span class="markYellow">consectetur adipiscing elit</span>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,<span class="markOrange">quis nostrud exercitation</span> ullamco laboris nisi ut aliquip ex ea commodo consequat. <span class="markOrange">Duis aute irure dolor in reprehenderit </span> in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            tags: ['Tag name1', 'Tag name1', 'Tag name1'],
          },
          {
            title:
              'Lorem2 ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor?',
            content:
              'Lorem ipsum dolor sit amet,<span class="markYellow">consectetur adipiscing elit</span>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,<span class="markOrange">quis nostrud exercitation</span> ullamco laboris nisi ut aliquip ex ea commodo consequat. <span class="markOrange">Duis aute irure dolor in reprehenderit </span> in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',

            tags: ['Tag name2', 'Tag name2', 'Tag name2'],
          },
        ],
      },
      {
        matchScore: 'Related match',
        size: 3,
        sectionsCard: [
          {
            title:
              'Lorem3 ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor?',
            content:
              'Lorem ipsum dolor sit amet,<span class="markYellow">consectetur adipiscing elit</span>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,<span class="markOrange">quis nostrud exercitation</span> ullamco laboris nisi ut aliquip ex ea commodo consequat. <span class="markOrange">Duis aute irure dolor in reprehenderit </span> in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',

            tags: ['Tag name3', 'Tag name3', 'Tag name3'],
          },
          {
            title:
              'Lorem4 ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor?',
            content:
              'Lorem ipsum dolor sit amet,<span class="markYellow">consectetur adipiscing elit</span>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,<span class="markOrange">quis nostrud exercitation</span> ullamco laboris nisi ut aliquip ex ea commodo consequat. <span class="markOrange">Duis aute irure dolor in reprehenderit </span> in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',

            tags: ['Tag name4', 'Tag name4', 'Tag name4'],
          },
          {
            title:
              'Lorem5 ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor?',
            content:
              'Lorem ipsum dolor sit amet,<span class="markYellow">consectetur adipiscing elit</span>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,<span class="markOrange">quis nostrud exercitation</span> ullamco laboris nisi ut aliquip ex ea commodo consequat. <span class="markOrange">Duis aute irure dolor in reprehenderit </span> in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',

            tags: ['Tag name5', 'Tag name5', 'Tag name5'],
          },
        ],
      },
    ],
  },
  mutations: {},
  getters: {
    GET_KNOWLEDGE_BASE_SEARCH_RESULTS(state) {
      return state.knowledgeBaseSearchResults
    },
    GET_TOTAL_KNOWLEDGE_BASE_LENGTH(state) {
      let length = 0
      state.knowledgeBaseSearchResults.forEach((section) => {
        length += section.sectionsCard.length
      })
      return length
    },
  },
}
